module.exports = __webpack_public_path__ + "public/images/welcome-collage.af2b7e14969422584ecb9ad3fcf58615.png";